export const MIN_CALENDAR_COLLAPSE_HEIGHT = 1050;
